import { useNavigate } from 'react-router-dom';
import { PrimaryButton } from '../components/ui/Button/Buttons';
import { PATHS } from '../constants/Paths.constants';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen min-w-screen flex items-center justify-center bg-white">
      <div className="flex flex-col items-center text-center gap-4 max-w-md">
        <h1 className="text-6xl font-bold text-purple-900">404</h1>
        <h2 className="text-2xl font-semibold text-gray-800">
          Page Not Found
        </h2>
        <p className="text-base text-gray-500">
          The page you are looking for does not exist.
        </p>
        <PrimaryButton onClick={() => navigate(PATHS.DASHBOARD)}>
          Go to Dashboard
        </PrimaryButton>
      </div>
    </div>
  );
}
